<template>
  <div>
    <div class="route-wrap">
      <div class="title">物流信息</div>

      <div class="content" v-if="hasData">
        <div class="expressMsg" v-if="DM.express_name !== '自取'">
          <span>{{DM.express_name}}&nbsp;</span>
          <span>{{DM.tracking_number}}</span>
        </div>
        <div class="expressMsg" v-if="DM.express_name === '自取'">
          <span>已自取</span>
        </div>
        <div class="routeDetail">
          <div class="item" v-for="(item, index) in routeFilter" :key="index">
            <span class="context">{{item.context}}&nbsp;</span>
            <span class="time">({{item.time}})</span>
          </div>
        </div>
        <div class="more" v-if="DM.express_name !== '自取' && routeFilter && routeFilter.length<=4 && seeMore" @click="more">查看更多</div>
        <div class="less" v-if="DM.express_name !== '自取' && routeFilter && routeFilter.length>3 && !seeMore" @click="less">收起</div>
      </div>

      <div class="content no-data" v-if="!hasData">{{noDataString}}</div>

    </div>
  </div>
</template>

<script>
import expressMap from '../../maps/express-map';
import Http from '../../libs/http';

export default {
  props: ['order'],
  data() {
    return {
      DM: {},
      expressMap,
      routeFilter: [],
      seeMore: true,
      hasData: false,
      noDataString: '',
    };
  },
  mounted() {
    const noDataString = '暂无物流信息，请耐心等待！';
    // 处理数据   不知道为啥这个created会执行两次,第一次拿不到order这个对象
    if (this.order.return_express) {
      Http.post('/order_return_express_query', {
        express_id: +this.order.return_express[0].express_id,
      })
        .then((data) => {
          this.DM = data;
          if (this.DM.data) {
            this.routeFilter = this.DM.data;
            if (this.routeFilter && this.routeFilter.length === 0) {
              this.noDataString = noDataString;
              this.hasData = false;
              return;
            }
            if (this.DM.data.length > 3) {
              this.routeFilter = this.DM.data.slice(0, 3);
            } else {
              this.routeFilter = this.DM.data;
            }
            if (this.DM.data && this.DM.data.length < 4) {
              // <=3条的时候就不显示更多的按钮
              this.seeMore = false;
            }
          }
          this.hasData = true;
        })
        .catch((e) => {
          if (e) console.log(e);
          this.hasData = false;
          this.noDataString = noDataString;
        });
    }
  },
  methods: {
    more() {
      this.seeMore = false;
      this.routeFilter = this.DM.data;
    },
    less() {
      this.seeMore = true;
      this.routeFilter = this.DM.data.slice(0, 3);
    },
  },
};
</script>

<style lang="less" scoped>
.route-wrap {
  background-color: #fff;
  margin-bottom: 15px;
  overflow: hidden;
  .title {
    margin: 21px 0 0 19px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .content {
    margin: 12px 40px 19px;
    background-color: #fbfbfb;
    padding: 22px 0 20px 22px;
    &.no-data {
      font-size: 14px;
    }
    .expressMsg {
      font-size: 14px;
    }
    .routeDetail {
      margin-top: 20px;
      margin-left: 12px;
      position: relative;
      .item {
        position: relative;
        &:after {
          content: "";
          position: absolute;
          background-color: #aaa;
          width: 1px;
          left: -9px;
          top: 11px;
          bottom: -24px;
        }
      }
      .item:last-child {
        &:after {
          display: none;
        }
      }
      .item:nth-child(1) {
        font-size: 14px;
        color: #5e9be1;
        margin-bottom: 13px;
        &:before {
          content: "";
          position: absolute;
          width: 7px;
          height: 7px;
          background-color: #5e9be1;
          border-radius: 50%;
          left: -12px;
          top: 5px;
        }
      }
      .item:not(:first-child) {
        font-size: 12px;
        color: #aaa;
        margin-bottom: 13px;
        &:before {
          content: "";
          position: absolute;
          width: 7px;
          height: 7px;
          background-color: #aaa;
          border-radius: 50%;
          left: -12px;
          top: 4px;
        }
      }
    }
    .more,
    .less {
      position: relative;
      display: inline-block;
      padding-right: 20px;
      margin-top: 10px;
      font-size: 12px;
      color: #5e9be1;
      cursor: pointer;
    }
    .more {
      &:before {
        border-bottom: 2px solid #5e9be1;
        border-right: 2px solid #5e9be1;
        content: "";
        position: absolute;
        height: 6px;
        width: 6px;
        right: 0px;
        top: 1px;
        -webkit-transform: rotateZ(45deg);
        transform: rotateZ(45deg);
      }
    }
    .less {
      &:before {
        border-left: 2px solid #5e9be1;
        border-top: 2px solid #5e9be1;
        content: "";
        position: absolute;
        height: 6px;
        width: 6px;
        right: 0px;
        top: 5px;
        -webkit-transform: rotateZ(45deg);
        transform: rotateZ(45deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-express-routes.vue